import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Lists area content only. The left nav (Menu + list items) is provided by MainLayout.
 */
function ListsLayout() {
  return <Outlet />;
}

export default ListsLayout;
